const urlMaker = (...args: any) => args.join("/");

export default urlMaker;
